import styled from 'styled-components';

export const Wrapper = styled.div`
  .legal-type {
    text-transform: capitalize;
  }
`;

export const ActionBoletoButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  button {
    height: 32px;
  }
`;
